// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1DYtg","content":"Consent_content__2jvNp","footer":"Consent_footer__40Pdh"};